import React from 'react'
import Link from 'gatsby-link'
import resolveLink from '../../utils/resolveLink'
import Heading from '../Heading'
import {TextColour} from '../../utils/ColourUtilities'
import FluidImage from 'src/utils/FluidImage'

const SubmenuItem = (props) => {
  return (
    <div className="flex flex-col lg:my-0 my-6">
        <Link to={resolveLink(`/${props.target.cached_url}`)}>
            <FluidImage className="mb-4" image={props.image} alt={props.title_2} />
            <Heading size="h6" className={`mb-0 leading-5 text-base ${TextColour(props.accent_colour)}`}>{props.title_1}&nbsp;</Heading>
            <Heading size="h6" className={`leading-5 mb-0 text-base`}>{props.title_2}&nbsp;</Heading>
        </Link>
    </div>
  )
};

export default SubmenuItem;
